/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'mn7g6F2ZGzGK6zxw9SReiJ.png': { uri: '/images/mn7g6F2ZGzGK6zxw9SReiJ.png' },
'sSUb73LJB4WKpVc2JpiLLq.png': { uri: '/images/sSUb73LJB4WKpVc2JpiLLq.png' },
'tJeZABHhqcYgzpYNYEyquV.png': { uri: '/images/tJeZABHhqcYgzpYNYEyquV.png' },
'okEUteLcJEMLxtptDHAy6P.png': { uri: '/images/okEUteLcJEMLxtptDHAy6P.png' },
'jRYMo4xsbpY5dzRZoP7pnS.png': { uri: '/images/jRYMo4xsbpY5dzRZoP7pnS.png' },
'sY1GStjcJXSFTeUWq9QpDV.png': { uri: '/images/sY1GStjcJXSFTeUWq9QpDV.png' },
'v2g7XnNo3x4XFisUzAAFwS.png': { uri: '/images/v2g7XnNo3x4XFisUzAAFwS.png' },
'emXgExapZbThsrZpAjPkQi.png': { uri: '/images/emXgExapZbThsrZpAjPkQi.png' },
'b3zUNPTk3w3oUS7UQxqyb8.png': { uri: '/images/b3zUNPTk3w3oUS7UQxqyb8.png' },
'3saiy3HCxofyhhyZHfKLM4.png': { uri: '/images/3saiy3HCxofyhhyZHfKLM4.png' },
'7NYdbBT16TScJF1U5zeDiR.png': { uri: '/images/7NYdbBT16TScJF1U5zeDiR.png' },
'r6bNXWqtD9ZjRBreC55mr6.png': { uri: '/images/r6bNXWqtD9ZjRBreC55mr6.png' },
'v6kvDV9GXGucZ5ovi4qT54.png': { uri: '/images/v6kvDV9GXGucZ5ovi4qT54.png' },
'gHMEZHsz3aiAhuAGgngo2E.png': { uri: '/images/gHMEZHsz3aiAhuAGgngo2E.png' },
'1yDwd7sRAuLwU7CDXZAivf.png': { uri: '/images/1yDwd7sRAuLwU7CDXZAivf.png' },
'djGDgkjehKSVxSoFLs7zNb.png': { uri: '/images/djGDgkjehKSVxSoFLs7zNb.png' },
'6xWv78raKBz9ET5hydC7zP.png': { uri: '/images/6xWv78raKBz9ET5hydC7zP.png' },
'huCAUXE8YpVqMVdjhK2FCt.png': { uri: '/images/huCAUXE8YpVqMVdjhK2FCt.png' },
'dU6N4hxviFZJ69exnthk2D.png': { uri: '/images/dU6N4hxviFZJ69exnthk2D.png' },
'u5rFuUh7XwyouF2GTqkLGD.png': { uri: '/images/u5rFuUh7XwyouF2GTqkLGD.png' },
'kdF7ySftkn7gjvK1VJZBSK.png': { uri: '/images/kdF7ySftkn7gjvK1VJZBSK.png' },
'tVKL4KpajTzUnHxZpLNLyR.png': { uri: '/images/tVKL4KpajTzUnHxZpLNLyR.png' },
'6J6nTsDXNyMsTJkft868o6.png': { uri: '/images/6J6nTsDXNyMsTJkft868o6.png' },
'2gVMkxbCDHLKXujEd9e6RX.png': { uri: '/images/2gVMkxbCDHLKXujEd9e6RX.png' },
'mXmMJday5odNuYYvVeGXUt.png': { uri: '/images/mXmMJday5odNuYYvVeGXUt.png' },
'9MW8L4qwvnegrxAK5dFR57.png': { uri: '/images/9MW8L4qwvnegrxAK5dFR57.png' },
'oXzuFsyAwoFWUcT6NuyxgP.png': { uri: '/images/oXzuFsyAwoFWUcT6NuyxgP.png' },
'kjfjqPCVyGp2ZehT5wn64W.png': { uri: '/images/kjfjqPCVyGp2ZehT5wn64W.png' },
'aEoyf8ivbVkxy51ABxXAvk.png': { uri: '/images/aEoyf8ivbVkxy51ABxXAvk.png' },
'5U6QP2xM2H1aho5FCGQRev.png': { uri: '/images/5U6QP2xM2H1aho5FCGQRev.png' },
'fA8Nngc3iszYdKvkU1fBmp.png': { uri: '/images/fA8Nngc3iszYdKvkU1fBmp.png' },
'vZvkuf6QM6zYCzM9gXiLwc.png': { uri: '/images/vZvkuf6QM6zYCzM9gXiLwc.png' },
'cocG1sUotGgUN33EPViyNk.png': { uri: '/images/cocG1sUotGgUN33EPViyNk.png' }
}

export default imageStaticSourcesByFileName
